"use client";

import { useAdContext } from "./AdContextProvider";
import { AdSlot } from "./AdSlot";

/**
 * Above-header ad slot, full-bleed.
 * Returns null entirely when no ad is configured (no empty wrapper/margin).
 * Centering and sizing are the responsibility of the ad creative itself.
 */
export function AboveHeaderSlot() {
    const adContext = useAdContext();
    if (!adContext?.slots["above-header"]) return null;

    return <AdSlot id="above-header" />;
}
